/* Filora — progressive-enhancement scroll reveals.
   Content is visible by default (no-JS safe); this adds the
   entrance animation only when JS + IntersectionObserver exist. */
(function () {
  var root = document.documentElement;
  root.classList.add('filora-js');

  function reveal() {
    var items = document.querySelectorAll('.filora-reveal');
    if (!('IntersectionObserver' in window) || !items.length) {
      // Fallback: just show everything.
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    items.forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }
})();
